<!-- 业务员提成修改列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <salesCommissionAction v-if="showStatus" ref="salesCommissionAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></salesCommissionAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :flagList="['status']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select v-if="formOneValue.entityField == 'status'" v-model="getRequestData[formOneValue.entityField]">
                            <el-option label="全部" value="">
                            </el-option>
                            <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys" :label="values.value" :value="values.key">
                            </el-option>
                        </el-select>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" show-overflow-tooltip :min-width="tableValye.fieldWeight" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                            </span>
                            <!-- 状态判断 -->
                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import salesCommissionAction from '@/components/salesCommissionAction.vue'
export default {
    components: {
        salesCommissionAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getButtonList()
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 1:
                    if (this.multipleSelection.length != 1) {
                        return this.$message({
                            message: "请先选中一条要操作的数据",
                            type: "error",
                        });
                    }
                    var dataInfo = this.multipleSelection[0];
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: "",
                        printSouce: '',
                        printJurId: '',
                    }
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.submitDataAction();
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        // 删除数据
        delDataAction() {
            if (this.multipleSelection.length != 1) {
                this.$message({
                    message: "请先选中一条要删除的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.multipleSelection[0];
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.bpId],
                    };
                    let responseData = await this.$http.bgmPrcdelOrder(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 提交审核
        submitDataAction() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定要提交审核?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.bgmPrcsubmit({
                        ids: this.multipleSelection.map(item => item.bpId),
                    });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.bgmPrcorderList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
        
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>